import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SearchBar = ({ onSearch, onAddUnit, onToggleFilters }) => {
  const [query, setQuery] = useState('');

  const handleChange = (e) => {
    setQuery(e?.target?.value);
    onSearch(e?.target?.value);
  };

  const handleClear = () => {
    setQuery('');
    onSearch('');
  };

  return (
    <div className="bg-card border-b border-border px-6 py-3 mt-[7.5rem]">
      <div className="container mx-auto flex items-center space-x-3">
        <button
          onClick={onToggleFilters}
          className="flex items-center space-x-2 px-3 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-muted/50 rounded-md transition-hover border border-border"
        >
          <Icon name="SlidersHorizontal" size={16} strokeWidth={2} />
          <span>Filters</span>
        </button>

        <div className="flex-1 relative">
          <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
            <Icon name="Search" size={16} strokeWidth={2} className="text-muted-foreground" />
          </div>
          <input
            type="text"
            value={query}
            onChange={handleChange}
            placeholder="Search by unit number, VIN, make, or model..."
            className="w-full pl-9 pr-9 py-2 text-sm bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary text-foreground placeholder:text-muted-foreground"
          />
          {query && (
            <button
              onClick={handleClear}
              className="absolute inset-y-0 right-3 flex items-center text-muted-foreground hover:text-foreground"
            >
              <Icon name="X" size={16} strokeWidth={2} />
            </button>
          )}
        </div>

        <Button
          variant="default"
          size="sm"
          iconName="Plus"
          iconPosition="left"
          onClick={onAddUnit}
        >
          Add Unit
        </Button>
      </div>
    </div>
  );
};

export default SearchBar;